const CursorTypes = {
  DRAG: "[data-cursor-drag]",
  MAGNETIC: "[data-cursor-magnetic]",
  NORMAL: "[data-cursor-normal]",
  COLOR: "[data-cursor-color]",
  FOLLOW: "[data-cursor-follow]",
  FOLLOWFIXED: "[data-cursor-follow-fixed]",
  AXIS_X: "[data-cursor-axis-x]",

  AXIS_Y: "[data-cursoraxis-Y]",
 // AXIS_X: "[cursor-axis-X]",
  AXIS_XY: "[data-cursor-axis-XY]",
  ARROW_L: "[data-cursor-arrow-L]",
  ARROW_R: "[data-cursor-arrow-R]",
  ARROW_D: "[data-cursor-arrow-D]",
  ARROW_Y: "[data-cursor-arrow-Y]",
  ARROW_INFO: "[data-cursor-arrow-info]",
};

export { CursorTypes }